import React from 'react';
import type { Raw } from 'types/vendor';
import { FiveVendorImageGrid } from './layouts/FiveVendorImageGrid';
import { FourVendorImageGrid } from './layouts/FourVendorImageGrid';
import { ThreeVendorImageGrid } from './layouts/ThreeVendorImageGrid';
import { TwoVendorImageGrid } from './layouts/TwoVendorImageGrid';
import Styles from './styles.scss';

interface CelebrationStorefrontsPhotoGridProps {
	vendors: Raw[];
}

export const CelebrationStorefrontsPhotoGrid: React.FC<
	CelebrationStorefrontsPhotoGridProps
> = ({ vendors }) => {
	const renderLayout = () => {
		switch (vendors.length) {
			case 2:
				return <TwoVendorImageGrid vendors={vendors} />;
			case 3:
				return <ThreeVendorImageGrid vendors={vendors} />;
			case 4:
				return <FourVendorImageGrid vendors={vendors} />;
			case 5:
				return <FiveVendorImageGrid vendors={vendors} />;
			default:
				return <ThreeVendorImageGrid vendors={vendors} />;
		}
	};

	return (
		<div className={Styles.photoGrid} data-testid="celebration-photo-grid">
			{renderLayout()}
		</div>
	);
};
